<template>
  <div>
    <div class="top-block">
      <h2 class="top-block__title top-block__title__text">
        {{ title }}
      </h2>
      <div class="top-block__filter-block">
        <slot />
      </div>
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="isLoading"
        key="loader"
        class="table-state-block__preloader spinner-fade-in"
      >
        <div class="spinner-border">
        </div>
      </div>
      <div
        v-else-if="isEmpty"
        key="empty-alert"
        class="table-state-block__empty-alert"
      >
        <h3>Список пуст.</h3>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TableHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
